import { usePlayer } from "../player/playerContext";
import { useQuery, useQueryCache } from "react-query";
import fetchApi from "../backend/fetchApi";
import { Syndicate } from "../models/syndicate";

const useSyndicate = (id: number) => {
  const [player] = usePlayer() as any;
  const queryCache = useQueryCache();

  const syndicatesUrl = player?.["_links"]?.syndicates?.href;
  const syndicateUrl = syndicatesUrl ? `${syndicatesUrl}/${id}` : null;

  const {
    data: syndicate,
    isLoading: loading,
    error,
  } = useQuery<Syndicate>(
    ["syndicate", id],
    async () => {
      const response = await fetchApi(syndicateUrl!);
      if (!response.ok) {
        throw new Error("Failed to fetch syndicate");
      }
      return response.json();
    },
    {
      enabled: !!syndicateUrl,
    }
  );

  const purchase = async () => {
    if (!syndicate || !player._links.syndicateShares.href) return;

    const response = await fetchApi(player._links.syndicateShares.href, {
      method: "POST",
      body: JSON.stringify({
        syndicateId: syndicate.id,
        stake: syndicate.stakePerShare,
        operatorFee: syndicate.operatorFeePerShare,
        agentFee: syndicate.agentFeePerShare,
        totalAmount: syndicate.totalAmountPerShare,
      }),
    });

    if (response.ok) {
      // Delay to allow for eventual consistency before refetching
      setTimeout(() => {
        queryCache.invalidateQueries("couponShares");
        queryCache.invalidateQueries("syndicates");
      }, 2000);
    }

    return response;
  };

  return { syndicate, loading, error, purchase };
};

export default useSyndicate;
